import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable, Loading } from "../../services/visualLibraryService";
import {
  LandingPageStyled,
  LandingContainerStyled,
  HeadingStyled,
  ButtonModalStyled,
  LogoStyled,
  SecondaryLogoStyled,
  TextStyled,
  TextDisclaimerStyled,
  LogoContainerStyled
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { getSdk } from "../../services/sdkService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { getVoucherDurationText } from "../../services/copyService";
import { getAppState } from "../../state/index";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";
import { getLandingTexts } from "./landingAdapter";
import { checkEvoucherEligiblity } from "../../services/eVoucherEligibilityService";
import getDurationFromVoucher from "../../utils/getDurationFromVoucher";
import * as Sentry from "@sentry/browser";

import { checkForUmanagedOrNonChangeableMop } from "../../services/billingService";
import Logo from "../../components/Logo";
import FreeLogo from "../../components/FreeLogo";

const PAGE = "landing";
const SIGNUP = "signup";
const ButtonModalFocus = withFocusable(ButtonModalStyled);
const joinFocusPath = "joinVoucherModal_passThru";
const loginFocusPath = "loginVoucherModal_passThru";
const startFocusPath = "startVoucherModal_passThru";
const closeFocusPath = "closeVoucherModal_passThru";
const proceedToHomePath = "proceedToHomeButtonModalFocusPath";

function getInvalidationModal(alreadyRedeemed) {
  let text = `pages.voucherRedemption.errors.evoucherPromotion.${
    alreadyRedeemed ? "validationFailed" : "noDeeplinkData"
  }.text`;

  return {
    dismissable: false,
    modalText: i18n.get(text),
    buttons: [
      {
        label: i18n.get("pages.voucherRedemption.proceedToHomePage"),
        displayBlock: true,
        focusPath: proceedToHomePath,
        buttonHandler: () => this.closeModal(true)
      },
      {
        label: i18n.get("pages.voucherRedemption.exitButton"),
        displayBlock: true,
        focusPath: "exitButtonModalFocusPath",
        buttonHandler: async () => {
          await getSdk();
          getSdk().systemManager.application.exit();
        }
      }
    ]
  };
}

function handleRequestError(error) {
  const { stateActions } = this.props;
  if (error.customCode === "EvoucherValidationFailed") {
    stateActions.showGlobalModal(getInvalidationModal.call(this, true));
  } else {
    stateActions.showGlobalModal(getInvalidationModal.call(this));
  }

  this.props.setFocus(proceedToHomePath);
}

class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      subscriptionText: ""
    };
    this.onBack = this.onBack.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
    this.redeemHandler = this.redeemHandler.bind(this);
    this.getActiveUserCloseHandler = this.getActiveUserCloseHandler.bind(this);
  }

  componentDidMount() {
    const {
      applicationState: { userLogged, voucherData, country },
      onRef
    } = this.props;
    trackPage(PAGE);
    onRef && onRef(this);

    (async () => {
      const texts = getLandingTexts(voucherData);
      if (voucherData && voucherData.checkEligibility) {
        this.setState({ isLoading: true });
        try {
          let data = voucherData.eligibilityData;
          if (!data) {
            data = await checkEvoucherEligiblity(
              country,
              voucherData.duration.unit +
                (voucherData.duration.duration.length < 2 ? "0" : "") +
                voucherData.duration.duration
            );
            voucherData.eligibilityData = data;
          }
          voucherData.data = data;
          const subscriptionText = data.vouchers
            .map(val => {
              return i18n.get(
                texts.subscriptions,
                getDurationFromVoucher(val.duration),
                val.subscriptions.map(v => i18n.get(`global.sections.${v}`)).join(", ")
              );
            })
            .join("<br />");
          this.setState({ subscriptionText });
          this.props.setFocus(`${userLogged ? startFocusPath : joinFocusPath}`);
        } catch (error) {
          Sentry.captureException(error);
          handleRequestError.call(this, error);
          // redirectTo.call(this, routes.home, historyMethods.REPLACE);
        } finally {
          this.setState({ isLoading: false });

          // setFocus(getGlobalButtonFocusPath("back"));s
        }
        console.debug(voucherData);
      } else {
        this.setState({
          subscriptionText: i18n.get(
            texts.subscriptions,
            ((voucherData || {}).duration || {}).duration,
            i18n.get(`global.sections.starzplay`)
          )
        });
      }
    })();
    this.props.setFocus(`${userLogged ? startFocusPath : joinFocusPath}`);
  }

  getActiveUserCloseHandler() {
    const {
      applicationState: { userAccountStatus }
    } = this.props;
    isUserAccountActive(userAccountStatus) && localStorage && localStorage.setItem("showVoucherPopup", false);
    this.enterHandler("landing_user_selects_later", routes.home);
  }

  enterHandler(eventAction, path, locationData) {
    trackEvent(SIGNUP, eventAction);
    redirectTo.call(this, path, locationData, historyMethods.REPLACE);
  }

  async redeemHandler() {
    this.setState({ isLoading: true });
    const path = await checkForUmanagedOrNonChangeableMop.call(this);
    this.setState({ isLoading: false });
    if (path && typeof path === "string") {
      redirectTo.call(this, path, null, historyMethods.REPLACE);
    }
  }

  onBack() {
    //redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  closeModal(redirectToLanding = false) {
    const {
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
    if (redirectToLanding) {
      redirectTo.call(this, routes.home, historyMethods.REPLACE);
    }
  }

  render() {
    const { userLogged, userAccountStatus, voucherData } = getAppState();
    const voucherDuration = !!voucherData && getVoucherDurationText(+voucherData.duration.duration, true);
    const texts = getLandingTexts(voucherData);
    return this.state.isLoading ? (
      <Loading overlay />
    ) : (
      <LandingPageStyled
        background={`http://mena-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images/tizen/samsung-promotion/background-${i18n.getDirection()}.png`}
      >
        <LandingContainerStyled>
          <LogoContainerStyled>
            <SecondaryLogoStyled
              src="http://mena-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images/tizen/samsung-promotion/logo-samsung-promotion.png"
              width="150"
              alt="SAMSUNG PROMOTION"
              inlineBlock
            />
            <LogoStyled>
              <FreeLogo />
            </LogoStyled>
          </LogoContainerStyled>
          <HeadingStyled rank="1" text={i18n.get(texts.title)} size="large" />

          <TextStyled text={i18n.get(texts.text)} size="medium" />
          {!!voucherData && <TextStyled text={this.state.subscriptionText} size="medium" showBullet />}
          <TextStyled text={i18n.get(texts.paragraph1)} size="medium" />

          {!userLogged ? (
            <>
              <ButtonModalFocus
                label={i18n.get(texts.join, voucherDuration).toUpperCase()}
                focusPath={joinFocusPath}
                onEnterPress={() => this.enterHandler("landing_user_selects_joinnow", routes.signup)}
                size="small"
                dataSnLeft={""}
                dataSnRight={""}
                dataSnDown={loginFocusPath}
                dataSnUp={""}
              />
              <ButtonModalFocus
                label={i18n.get("global.sections.login").toUpperCase()}
                focusPath={loginFocusPath}
                onEnterPress={() =>
                  this.enterHandler("landing_user_selects_login", routes.pin, {
                    backDestination: routes.home,
                    nextPage: routes.redeem
                  })
                }
                size="small"
                dataSnLeft={""}
                dataSnRight={""}
                dataSnDown={""}
                dataSnUp={joinFocusPath}
              />
            </>
          ) : (
            <>
              <ButtonModalFocus
                label={i18n.get(texts.start, voucherDuration).toUpperCase()}
                focusPath={startFocusPath}
                onEnterPress={() => this.redeemHandler()}
                displayBlock
                size="small"
                dataSnUp={""}
                dataSnDown={`@${closeFocusPath}`}
                dataSnLeft={""}
                dataSnRight={""}
              />
              <ButtonModalFocus
                label={
                  isUserAccountActive(userAccountStatus)
                    ? i18n.get(texts.notNow).toUpperCase()
                    : i18n.get(texts.notNow).toUpperCase()
                }
                focusPath={closeFocusPath}
                onEnterPress={this.getActiveUserCloseHandler}
                displayBlock
                size="small"
                dataSnUp={`@${startFocusPath}`}
                dataSnDown={""}
                dataSnLeft={""}
                dataSnRight={""}
              />
            </>
          )}

          <TextDisclaimerStyled text={i18n.get(texts.disclaimer)} size="xsmall" />
        </LandingContainerStyled>
      </LandingPageStyled>
    );
  }
}

export default withAppState(withSubtheme(LandingPage));
